export const UPDATE_UNREAD_TOTAL = "UPDATE_UNREAD_TOTAL";
